// import Vue from 'vue'
// import Vuex from 'vuex'
//
// Vue.use(Vuex)

const keep = (
  {
    state: {
      keepAlive: []
    },
    mutations: {
      setKeepAlive: (state, keepAlive) => {
        state.keepAlive = keepAlive
      }
    },
    getters: {
      keepAlive: state => state.keepAlive
    }
  }
)

export default keep



// WEBPACK FOOTER //
// ./src/store/modules/keep.js